import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Main, Card, Row } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import useWindowSize from './../../hooks/useWindowSize';
import Avatar from 'react-avatar';
import api from './../../services/api';

export const Testimony = ({ params, primaryColor, query }) => {
  const [current, setCurrent] = useState(0);
  const windowSize = useWindowSize();
  const [testimony, setTestimony] = useState([]);

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const companyTestimonyUrl =
        label && page_label
          ? `pages/sections/testimonial/get/${label}/${page_label}`
          : `pages/sections/testimonial/get/${label}`;

      try {
        const { data } = await api.get(companyTestimonyUrl);
        
        // Verificação de segurança para evitar erros quando data é undefined
        if (data && data.data) {
          setTestimony(data.data);
        } else {
          console.warn('API response data structure is invalid in Testimony component:', data);
          setTestimony([]);
        }
      } catch (error) {
        console.error('Error loading testimonies:', error);
        setTestimony([]);
      }
    }

    let isMounted = true;

    if (isMounted && query) {
      load();
    }

    return () => {
      isMounted = false;
    };
  }, [params]);

  const [height, setHeight] = useState(undefined);

  useEffect(() => {
    let box = document.getElementsByClassName('box');
    if (box) {
      let h = 0;
      Array.prototype.forEach.call(box, function(el) {
        if (h < el.offsetHeight) {
          h = el.offsetHeight;
        }
      });
      setHeight(h);
    }
  }, [testimony]);

  useEffect(() => {
    let pressed = false;
    let startX;
    let x;
    let totalItem = 0;
    if (Array.isArray(testimony)) {
      totalItem = 0; // Se testimony é um array vazio, totalItem é 0
    } else if (testimony?.items && typeof testimony.items === 'object') {
      // Converte items para um array de valores e aplica o filtro
      totalItem = Object.values(testimony.items).filter(t => t.active).length;
    }
    const sliderContainer = document.querySelector('.container-slider');
    const innerSlider = document.querySelector('.inner-slider');

    sliderContainer.addEventListener('mouseenter', () => {
      sliderContainer.style.cursor = 'grab';
    });

    sliderContainer.addEventListener('mousedown', e => {
      pressed = true;
      startX = e.offsetX - innerSlider.offsetLeft;
      sliderContainer.style.cursor = 'grabbing';
    });

    sliderContainer.addEventListener('mouseup', e => {
      sliderContainer.style.cursor = 'grab';
      pressed = false;
    });

    sliderContainer.addEventListener('mouseleave', () => {
      sliderContainer.style.cursor = 'grab';
      pressed = false;
    });

    sliderContainer.addEventListener('touchstart', e => {
      pressed = true;
      const touches = e.touches || e.originalEvent.touches;
      startX = touches[0].clientX - innerSlider.offsetLeft;
    });

    sliderContainer.addEventListener('touchend', e => {
      pressed = false;
    });

    sliderContainer.addEventListener('mousemove', e => {
      if (!pressed) return;
      e.preventDefault();

      x = e.offsetX;
      innerSlider.style.left = `${x - startX}px`;
      const total = Math.trunc(((x - startX) * -1) / 363.71);
      if (total > 1 && total <= totalItem) {
        setCurrent(total - 1);
      } else if (total <= 1) {
        setCurrent(0);
      }
      setTimeout(() => {
        if (x - startX >= 0) {
          innerSlider.style.left = `0px`;
        }
        if (-totalItem * 400 > x - startX) {
          innerSlider.style.left = `${-totalItem * 363.71}px`;
        }
      }, 600);
    });

    sliderContainer.addEventListener('touchmove', e => {
      if (!pressed) return;
      e.preventDefault();
      const touches = e.touches || e.originalEvent.touches;
      x = touches[0].clientX;
      innerSlider.style.left = `${x - startX}px`;
      const total = Math.trunc(((x - startX) * -1) / 349);
      if (total > 0 && total <= totalItem) {
        setCurrent(total);
      } else if (total <= 0) {
        setCurrent(0);
      }
      setTimeout(() => {
        if (x - startX >= 0) {
          innerSlider.style.left = `12px`;
          setCurrent(0);
        }
        if (-totalItem * 349 > x - startX) {
          innerSlider.style.left = `${-totalItem * 349}px`;
          setCurrent(totalItem - 1);
        }
      }, 600);
    });
  }, [testimony]);

  function handleClickBullet(index) {
    const innerSlider = document.querySelector('.inner-slider');
    if (index === 0) {
      innerSlider.style.left = `0px`;
    } else {
      innerSlider.style.left = `-${(index + 1) * 363.71}px`;
    }
    setCurrent(index);
  }

  return (
    <Main id="testimonials" actived={testimony?.active}>
      <Container className="container-testimonial">
        <h2>“</h2>
        <div
          className="container-slider"
          style={{ height: height > 0 ? height : 'auto' }}
        >
          <div className="inner-slider">
            {windowSize.width > 950
              ? Array.isArray(testimony)
                ? null // Se testimony é um array vazio, não renderiza nada
                : testimony?.items &&
                  typeof testimony.items === 'object' &&
                  Object.values(testimony.items)
                    .filter(t => t.active)
                    .map((testimony, index) => (
                      <Card
                        key={index}
                        className="box"
                        style={{ height: height > 0 ? height : 'auto' }}
                      >
                        <h4>{testimony?.description}</h4>
                        <div className="container-avatar">
                          <Avatar
                            size="80"
                            round
                            name={testimony?.name}
                            src={testimony?.file?.url}
                          />
                          <div className="container-name-post">
                            <h6>{testimony?.name}</h6>
                            <h6>{testimony?.office}</h6>
                          </div>
                        </div>
                      </Card>
                    ))
              : Array.isArray(testimony)
              ? null // Se testimony é um array vazio, não renderiza nada
              : testimony?.items &&
                typeof testimony.items === 'object' &&
                Object.values(testimony.items).filter(t => t.active).length > 0 &&
                Object.values(testimony.items)
                  .filter(t => t.active)
                  .map((testimony, index) => (
                    <Card
                      key={index}
                      className="box"
                      style={{ height: height > 0 ? height : 'auto' }}
                    >
                      <h4>{testimony?.description}</h4>
                      <div className="container-avatar">
                        <div className="container-name-post">
                          <h6>{testimony?.name}</h6>
                          <h6>{testimony?.office}</h6>
                        </div>
                        <Avatar
                          size="80"
                          round
                          name={testimony?.name}
                          src={testimony?.file?.url}
                        />
                      </div>
                    </Card>
                  ))}
          </div>
        </div>
      </Container>
      <Row
        hide={
          Array.isArray(testimony)
            ? true
            : testimony?.items &&
              typeof testimony.items === 'object' &&
              Object.values(testimony.items).filter(t => t.active).length <= 2
        }
        total={
          Array.isArray(testimony)
            ? 0
            : testimony?.items &&
              typeof testimony.items === 'object' &&
              Object.values(testimony.items).filter(t => t.active).length
        }
      >
        {Array.isArray(testimony)
          ? null
          : testimony?.items &&
            typeof testimony.items === 'object' &&
            Object.values(testimony.items)
              .filter(t => t.active)
              .map((el, index) => (
                <FontAwesomeIcon
                  key={index}
                  onClick={() => {
                    handleClickBullet(index);
                  }}
                  style={{ cursor: 'pointer' }}
                  icon={faCircle}
                  color={index === current ? primaryColor || '#403294' : '#C0B6F2'}
                />
              ))}
      </Row>
    </Main>
  );
};

Testimony.propType = {
  testimony: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      post: PropTypes.string.isRequired,
      img: PropTypes.string,
      description: PropTypes.string.isRequired,
    })
  ),
};
